import { ECommonRequestStatusesForAssetRequest, TCommonRequestStatusesForAssetRequest } from '@enums/asset';
import { TKeyOfUserRoles } from '@enums/common';

import {
	ERequestStatusesForAOSignatoryDecline,
	ERequestStatusesForAssetManagerAODecline,
	ERequestStatusesForMNODecline,
	ERoles,
} from '@components/routes/AdminPanel/AssetsRent/RequestReservationCard/constants';

const {
	done,
	cancelled,
	declined,
	contract,
	ended,
} = ECommonRequestStatusesForAssetRequest;

const REQUESTS_LIST: TCommonRequestStatusesForAssetRequest[] = [contract, cancelled, declined, done, ended];

export function checkIsAbleToDecline({
	role,
	accessPermission,
	requestStatus,
}: {
	role?: string;
	accessPermission?: Record<TKeyOfUserRoles, boolean>;
	requestStatus?: string;
}) {
	if (!role
		|| !requestStatus
		|| !accessPermission
		|| requestStatus === cancelled
		|| requestStatus === declined
		|| requestStatus == done) return false;

	if (role === ERoles.ao) {
		switch (true) {
			case accessPermission?.assetOwnerManageRequests && !accessPermission.assetOwnerSignatory:
				return Object.values(ERequestStatusesForAssetManagerAODecline)
					.some((status) => status === requestStatus);

			case accessPermission.assetOwnerSignatory && !accessPermission?.assetOwnerManageRequests:
				return Object.values(ERequestStatusesForAOSignatoryDecline)
					.some((status) => status === requestStatus);

			case accessPermission?.assetOwnerManageRequests && accessPermission.assetOwnerSignatory:
				return Object.values(ERequestStatusesForAssetManagerAODecline)
						.some((status) => status === requestStatus)
					|| Object.values(ERequestStatusesForAOSignatoryDecline)
						.some((status) => status === requestStatus);

			default:
				return false;
		}
	}

	if (role === ERoles.mno
		&& (accessPermission.networkOperatorAssetEnquirer || accessPermission.assetConsumerAssetEnquirer)
	)
		return Object.values(ERequestStatusesForMNODecline).some((status) => status === requestStatus);

	return false;
}

export const checkIsAbleToViewAttachedDocuments = ({
	role,
	accessPermission,
	requestStatus,
}: {
	role?: string;
	accessPermission?: Record<TKeyOfUserRoles, boolean>;
	requestStatus?: TCommonRequestStatusesForAssetRequest;
}) => {
	if (!role
		|| !requestStatus
		|| !accessPermission
		|| (role !== ERoles.ao && role !== ERoles.mno)
	) return false;

	if (role === ERoles.mno
		&& (accessPermission.networkOperatorAssetEnquirer || accessPermission.assetConsumerAssetEnquirer)
	)
		return ECommonRequestStatusesForAssetRequest.done === requestStatus
			|| ECommonRequestStatusesForAssetRequest.ended === requestStatus;

	const isValidStatus = REQUESTS_LIST.includes(requestStatus);

	return (accessPermission.assetOwnerSignatory || accessPermission.assetOwnerManageRequests) && isValidStatus;
};
